import React from 'react';
import { Tooltip } from 'antd';

// Lightweight vertical bar chart (no chart lib). Used for the grade distribution
// and the submission-activity timeline. `data`: [{ label, count }].
const BarChart = ({ data = [], height = 150, color = '#1890ff', highlightMax = false }) => {
    const max = Math.max(1, ...data.map((d) => d.count));
    const peak = Math.max(...data.map((d) => d.count));
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, height }}>
                {data.map((d, i) => {
                    const ratio = d.count / max;
                    const isPeak = highlightMax && d.count === peak && peak > 0;
                    const barColor = isPeak ? color : `${color}cc`;
                    return (
                        <div
                            key={i}
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                height: '100%',
                            }}
                        >
                            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--wsb-text)', marginBottom: 5 }}>
                                {d.count}
                            </span>
                            <Tooltip title={`${d.label}: ${d.count}`}>
                                <div
                                    style={{
                                        width: '100%',
                                        maxWidth: 48,
                                        height: `${d.count > 0 ? Math.max(ratio * 100, 6) : 2}%`,
                                        minHeight: d.count > 0 ? 8 : 3,
                                        background:
                                            d.count > 0
                                                ? `linear-gradient(180deg, ${barColor} 0%, ${color}77 100%)`
                                                : 'var(--wsb-border)',
                                        borderRadius: '8px 8px 5px 5px',
                                        boxShadow: isPeak ? `0 6px 16px ${color}44` : 'none',
                                        transition: 'height .4s ease',
                                    }}
                                />
                            </Tooltip>
                        </div>
                    );
                })}
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 8, borderTop: '1px solid var(--wsb-border)', paddingTop: 8 }}>
                {data.map((d, i) => (
                    <div key={i} style={{ flex: 1, textAlign: 'center', fontSize: 11.5, color: 'var(--wsb-muted)' }}>
                        {d.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BarChart;
